import { ChangeEvent, useCallback, useState } from 'react';
import { useAppDispatch } from '../../hooks';
import { login } from '../../lib/api';
import { setUser } from '../../redux/appSlice';

interface LoginFormProps {
  onRegisterClick: () => void;
  onLostPasswordClick: () => void;
}

export const LoginForm = ({
  onRegisterClick,
  onLostPasswordClick,
}: LoginFormProps) => {
  const dispatch = useAppDispatch();
  const [username, setUsername] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [resultMessage, setResultMessage] = useState<string>('');
  const [formEnabled, setFormEnabled] = useState<boolean>(true);

  const handleLoginClick = useCallback(
    async (event: React.FormEvent) => {
      event.preventDefault();
      try {
        setFormEnabled(false);
        const user = await login(username, password);
        dispatch(setUser(user));
      } catch (e) {
        setResultMessage('We couldn\'t log you in with those credentials. Try again or click "I\'ve lost my password" to reset it.');
      } finally {
        setFormEnabled(true);
      }
    },
    [username, password, dispatch]
  );

  return (
    <div className="login-form-content">
      <div className="login-intro">
        <p>
          Welcome to the Age-Positive image library. Please login using the form
          below
        </p>
        <p>
          Please note that you don't need an account or to request an account to
          fully access the public image library. However, if you would like an account so that you can create your own collections and you aren’t required to input your details whenever downloading an image please{' '}
          <button className="login-register-link" onClick={onRegisterClick}>
            apply here
          </button>
        </p>
      </div>
      <form onSubmit={handleLoginClick}>
        <div className="input-wrapper">
          <label>Username:</label>
          <input
            disabled={!formEnabled}
            type="text"
            value={username}
            onChange={(event: ChangeEvent<HTMLInputElement>) => {
              setUsername(event.target.value);
            }}
          />
        </div>
        <div className="input-wrapper">
          <label>Password:</label>
          <input
            disabled={!formEnabled}
            type="password"
            value={password}
            onChange={(event: ChangeEvent<HTMLInputElement>) => {
              setPassword(event.target.value);
            }}
          />
        </div>
        <button type="button" className="lost-password-link" onClick={onLostPasswordClick}>
          I've lost my password
        </button>
        {resultMessage && <p className='error'>{resultMessage}</p>}
        <button type="submit" className="submit-button" disabled={!formEnabled}>
          Login
        </button>
      </form>
      <div>
        Don't have an account?{' '}
        <button type="button" className="login-register-link" onClick={onRegisterClick}>
          Apply here
        </button>
      </div>
    </div>
  );
};
